import React from 'react';


export const fleche = () =>
    <svg width={30} version="1.1" id="fleche" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 36 35" style={{ enableBackground: 'new 0 0 36 35', fill: '#F2C718' }} xmlSpace="preserve">
        <style type="text/css" />
        <g>
            <path className="st0" d="M34.54,11.51c-1.6-4.49-4.85-8.09-9.16-10.13S16.23-0.9,11.74,0.7C7.25,2.3,3.65,5.55,1.61,9.86
                                c-2.04,4.31-2.29,9.15-0.69,13.64c0.14,0.38,0.55,0.58,0.93,0.44c0.38-0.14,0.58-0.55,0.44-0.93c-1.47-4.12-1.25-8.57,0.63-12.53
                                C4.8,6.52,8.1,3.54,12.23,2.07C16.35,0.6,20.8,0.82,24.76,2.7c3.96,1.88,6.94,5.18,8.41,9.31c1.47,4.12,1.25,8.57-0.63,12.53
                                c-1.88,3.96-5.18,6.94-9.31,8.41c-4.62,1.65-9.69,1.15-13.91-1.37c-0.35-0.21-0.79-0.09-1,0.25c-0.21,0.34-0.09,0.79,0.25,1
                                c2.81,1.68,5.97,2.53,9.14,2.53c2.02,0,4.05-0.34,6-1.04c4.49-1.6,8.09-4.85,10.13-9.16C35.9,20.85,36.14,16,34.54,11.51" />
            <path className="st0" d="M25.72,17.51c0-0.4-0.33-0.73-0.73-0.73H6.91c-0.4,0-0.73,0.33-0.73,0.73c0,0.4,0.33,0.73,0.73,0.73h18.09
                                C25.4,18.23,25.72,17.91,25.72,17.51" />
            <path className="st0" d="M19.93,25.1c-0.28,0.28-0.28,0.74,0,1.03c0.14,0.14,0.33,0.21,0.51,0.21c0.19,0,0.37-0.07,0.51-0.21l8.11-8.11
                                c0.28-0.28,0.28-0.74,0-1.03l-8.11-8.11c-0.28-0.28-0.74-0.28-1.03,0c-0.28,0.28-0.28,0.74,0,1.03l7.6,7.6L19.93,25.1z" />
        </g>
    </svg>

export const flecheRouge = () =>
    <svg width={30} version="1.1" id="flecheRouge" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 36 35" style={{ enableBackground: 'new 0 0 36 35', fill: '#b11f27' }} xmlSpace="preserve">
        <style type="text/css" />
        <g>
            <path className="st0" d="M34.54,11.51c-1.6-4.49-4.85-8.09-9.16-10.13S16.23-0.9,11.74,0.7C7.25,2.3,3.65,5.55,1.61,9.86
                                c-2.04,4.31-2.29,9.15-0.69,13.64c0.14,0.38,0.55,0.58,0.93,0.44c0.38-0.14,0.58-0.55,0.44-0.93c-1.47-4.12-1.25-8.57,0.63-12.53
                                C4.8,6.52,8.1,3.54,12.23,2.07C16.35,0.6,20.8,0.82,24.76,2.7c3.96,1.88,6.94,5.18,8.41,9.31c1.47,4.12,1.25,8.57-0.63,12.53
                                c-1.88,3.96-5.18,6.94-9.31,8.41c-4.62,1.65-9.69,1.15-13.91-1.37c-0.35-0.21-0.79-0.09-1,0.25c-0.21,0.34-0.09,0.79,0.25,1
                                c2.81,1.68,5.97,2.53,9.14,2.53c2.02,0,4.05-0.34,6-1.04c4.49-1.6,8.09-4.85,10.13-9.16C35.9,20.85,36.14,16,34.54,11.51" />
            <path className="st0" d="M25.72,17.51c0-0.4-0.33-0.73-0.73-0.73H6.91c-0.4,0-0.73,0.33-0.73,0.73c0,0.4,0.33,0.73,0.73,0.73h18.09
                                C25.4,18.23,25.72,17.91,25.72,17.51" />
            <path className="st0" d="M19.93,25.1c-0.28,0.28-0.28,0.74,0,1.03c0.14,0.14,0.33,0.21,0.51,0.21c0.19,0,0.37-0.07,0.51-0.21l8.11-8.11
                                c0.28-0.28,0.28-0.74,0-1.03l-8.11-8.11c-0.28-0.28-0.74-0.28-1.03,0c-0.28,0.28-0.28,0.74,0,1.03l7.6,7.6L19.93,25.1z" />
        </g>
    </svg>

export const flecheCouleur = props =>
    <svg width={props.width || 30} version="1.1" id="flecheCouleur" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 36 35" style={{ enableBackground: 'new 0 0 36 35', fill: props.couleur }} xmlSpace="preserve">
        <style type="text/css" />
        <g>
            <path className="" d="M34.54,11.51c-1.6-4.49-4.85-8.09-9.16-10.13S16.23-0.9,11.74,0.7C7.25,2.3,3.65,5.55,1.61,9.86
                                c-2.04,4.31-2.29,9.15-0.69,13.64c0.14,0.38,0.55,0.58,0.93,0.44c0.38-0.14,0.58-0.55,0.44-0.93c-1.47-4.12-1.25-8.57,0.63-12.53
                                C4.8,6.52,8.1,3.54,12.23,2.07C16.35,0.6,20.8,0.82,24.76,2.7c3.96,1.88,6.94,5.18,8.41,9.31c1.47,4.12,1.25,8.57-0.63,12.53
                                c-1.88,3.96-5.18,6.94-9.31,8.41c-4.62,1.65-9.69,1.15-13.91-1.37c-0.35-0.21-0.79-0.09-1,0.25c-0.21,0.34-0.09,0.79,0.25,1
                                c2.81,1.68,5.97,2.53,9.14,2.53c2.02,0,4.05-0.34,6-1.04c4.49-1.6,8.09-4.85,10.13-9.16C35.9,20.85,36.14,16,34.54,11.51" />
            <path className="" d="M25.72,17.51c0-0.4-0.33-0.73-0.73-0.73H6.91c-0.4,0-0.73,0.33-0.73,0.73c0,0.4,0.33,0.73,0.73,0.73h18.09
                                C25.4,18.23,25.72,17.91,25.72,17.51" />
            <path className="" d="M19.93,25.1c-0.28,0.28-0.28,0.74,0,1.03c0.14,0.14,0.33,0.21,0.51,0.21c0.19,0,0.37-0.07,0.51-0.21l8.11-8.11
                                c0.28-0.28,0.28-0.74,0-1.03l-8.11-8.11c-0.28-0.28-0.74-0.28-1.03,0c-0.28,0.28-0.28,0.74,0,1.03l7.6,7.6L19.93,25.1z" />
        </g>
    </svg>


export const contact = () =>
    <svg height={100} version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" enableBackground="new 0 0 512 512" xmlSpace="preserve">
        <path fill="#FFFFFF" d="M316,260c-5.52,0-10,4.48-10,10s4.48,10,10,10s10-4.48,10-10S321.52,260,316,260z" />
        <path fill="#FFFFFF" d="M102.168,369.785l-100,126c-2.387,3.004-2.84,7.109-1.172,10.562C2.664,509.805,6.164,512,10,512h492
                            c3.836,0,7.336-2.195,9.004-5.652c1.672-3.453,1.215-7.559-1.172-10.562l-100-126C407.938,367.395,405.051,366,402,366h-87.598
                            l74.785-117.296C406.73,222.403,416,191.731,416,160C416,71.778,344.227,0,256,0S96,71.778,96,160
                            c0,31.73,9.27,62.398,26.812,88.703L197.598,366H110C106.949,366,104.066,367.395,102.168,369.785z M64.832,449h60.465l-34.125,43
                            H30.703L64.832,449z M210.352,386l27.414,43h-71.062l34.129-43H210.352z M301.652,386h9.52l34.125,43h-71.059L301.652,386z
                            M361.172,449l34.125,43H116.703l34.129-43H361.172z M420.832,492l-34.129-43h60.469l34.125,43H420.832z M431.297,429h-60.465
                            l-34.129-43h60.469L431.297,429z M139.508,237.688C124.129,214.665,116,187.801,116,160c0-77.195,62.805-140,140-140
                            s140,62.805,140,140c0,27.801-8.129,54.664-23.504,77.688c-0.043,0.059-0.078,0.117-0.117,0.176
                            C365.812,248.165,261.059,412.469,256,420.398c-12.723-19.957-103.422-162.215-116.379-182.535
                            C139.586,237.805,139.547,237.747,139.508,237.688z M175.297,386l-34.125,43H80.703l34.129-43H175.297z" />
        <path fill="#FFFFFF" d="M256,260c54.898,0,100-44.457,100-100c0-55.141-44.859-100-100-100S156,104.86,156,160
                            C156,215.559,201.117,260,256,260z M256,80c44.113,0,80,35.887,80,80c0,44.523-36.176,80-80,80c-43.836,0-80-35.477-80-80
                            C176,115.887,211.887,80,256,80z" />
        <path fill="#FFFFFF" d="M298.121,294.125c-4.727-2.852-10.875-1.328-13.727,3.402l-36.961,61.32
                            c-2.852,4.73-1.328,10.875,3.402,13.727c4.75,2.863,10.887,1.309,13.727-3.402l36.961-61.32
                            C304.375,303.121,302.852,296.977,298.121,294.125z" />
    </svg>

export const next = () =>
    <svg
        height={40}
        id="next"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 145 143">
        <defs>
            <style dangerouslySetInnerHTML={{ __html: ".next-1,.next-4{fill:none;}.next-2{fill:#3f3f40;}.next-3{clip-path:url(#nextCP);}.next-4{stroke:#3f3f40;stroke-width:4.01px;}" }} />
            <clipPath id="nextCP">
                <rect className="next-1" x={1} width={143} height={143} />
            </clipPath>
        </defs>
        <title>Plan de travail 1</title>
        <polygon className="next-2" points="57.34 99.22 60.47 102.86 96.79 70.8 60.47 37.49 57.34 40.92 89.52 70.8 57.34 99.22" />
        <g className="next-3">
            <ellipse className="next-4" cx="72.5" cy="71.5" rx={69} ry="69.01" />
        </g>
    </svg>




export const prev = () =>
    <svg
        height={40}
        id="prev"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 145 143">
        <defs>
            <style dangerouslySetInnerHTML={{ __html: ".prev-1,.prev-5{fill:none;}.prev-2{clip-path:url(#prevCP);}.prev-3{fill:url(#Dégradé_sans_nom_3);}.prev-4{clip-path:url(#prevCP3);}.prev-5{stroke:#3f3f40;stroke-width:4.07px;}" }} />
            <clipPath id="prevCP">
                <polygon className="prev-1" points="87.98 42.55 84.85 38.92 48.54 70.97 84.85 104.28 87.98 100.86 55.8 70.97 87.98 42.55" />
            </clipPath>
            <linearGradient
                id="Dégradé_sans_nom_3" x1="0.8" y1="71.6" x2="2.04" y2="71.6"
                gradientTransform="matrix(0, 0, 0, 0, 1169.82, 28478.24)"
                gradientUnits="userSpaceOnUse"><stop offset={0}
                    stopColor="#231f20" />
                <stop offset="0.08"
                    stopColor="#231f20" />
                <stop offset="0.18" stopColor="#840029" />
                <stop offset="0.57" stopColor="#231f20" />
                <stop offset={1} stopColor="#2b2e37" />
                <stop offset={1} stopColor="#2b2e37" />
            </linearGradient>
            <clipPath id="prevCP3">
                <rect className="prev-1" x="0.8" width={143} height={143} />
            </clipPath>
        </defs>
        <g className="prev-2">
            <rect className="prev-3" x="48.54" y="38.92" width="39.45" height="65.36" />
        </g>
        <g className="prev-4">
            <circle className="prev-5" cx="72.3" cy="71.52" r="68.97" />
        </g>
    </svg>


export const suivant = ({height, color}) =>
    <svg
        height={height || 25}
        id="suivant"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 145 143">
        <defs>
            <style dangerouslySetInnerHTML={{ __html: `.suivant_next-2{fill:${color || "#fff"};}` }} />
        </defs>
        <polygon className="suivant_next-2" points="57.34 99.22 60.47 102.86 96.79 70.8 60.47 37.49 57.34 40.92 89.52 70.8 57.34 99.22" />
    </svg>
export const precedant = ({height, color}) =>
    <svg
        height={height || 20}
        id="precedant"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 145 143">
        <defs>
            <style dangerouslySetInnerHTML={{ __html: `.precedant_prev-1,.precedant_prev-2{clip-path:url(#precedant_prevCP);}.precedant_prev-3{fill:${color || "#fff"};}}` }} />
            <clipPath id="precedant_prevCP">
                <polygon className="precedant_prev-1" points="87.98 42.55 84.85 38.92 48.54 70.97 84.85 104.28 87.98 100.86 55.8 70.97 87.98 42.55" />
            </clipPath>
        </defs>
        <g className="precedant_prev-2">
            <rect className="precedant_prev-3" x="48.54" y="38.92" width="60" height="65.36" />
        </g>
    </svg>

export const facebook = props => <svg
    width={props.width || 40}
    id="facebook"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 145 143">
    <defs>
        <style dangerouslySetInnerHTML={{ __html: ".facebook-1{fill:none;}.facebook-2{clip-path:url(#facebookCP);}.facebook-3{fill:#fff;}" }} />
        <clipPath id="facebookCP">
            <rect className="facebook-1" x={1} width="143.06" height={143} />
        </clipPath>
    </defs>
    <g className="facebook-2">
        <path className="facebook-3" style={{ fill: props.couleur || "#fff" }} d="M72.63,0A71.65,71.65,0,0,0,1,71.47c0,33.16,23.61,62.59,56.11,69.91A72.4,72.4,0,0,0,72.63,143a44,44,0,0,0,6.39-.31c36.32-2.95,65-34.22,65-71.22A71.55,71.55,0,0,0,72.63,0m0,3.49A68,68,0,0,1,78.41,139.2a32.06,32.06,0,0,1-5.78.35A66.15,66.15,0,0,1,57.88,138,68,68,0,0,1,72.63,3.49" />
        <path className="facebook-3" style={{ fill: props.couleur || "#fff" }} d="M80.35,57.2c1-1.24,3.15-2.13,6.15-2.13a35.47,35.47,0,0,1,9.29,1.31l2.65-14.27a50.15,50.15,0,0,0-16.86-2.45c-5.8,0-10.36.89-14,3S61.39,47,60,50.38c-1.41,3-2.11,8-2.11,14.4v5.61H46.63v16.3H57.88V138a66.15,66.15,0,0,0,14.75,1.58,32.93,32.93,0,0,0,5.78-.34V86.69H93.33V70.39H78.41V65.13c0-4,.54-6.5,1.94-7.93" />
    </g>
</svg>

export const twitter = props => <svg
    width={props.width || 40}
    id="twitter"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 145 143">
    <defs>
        <style dangerouslySetInnerHTML={{ __html: ".twitter-1{fill:none;}.twitter-2{clip-path:url(#twitterCP);}.twitter-3{fill:#fff;}" }} />
        <clipPath id="twitterCP">
            <rect className="twitter-1" x={1} width="142.98" height={143} />
        </clipPath>
    </defs>
    <g className="twitter-2">
        <path style={{ fill: props.couleur || "#fff" }} className="twitter-3 pub-twitter" d="M72.52,0A71.5,71.5,0,1,0,144,71.5,71.6,71.6,0,0,0,72.52,0m0,3.49a68,68,0,1,1-68,68,68,68,0,0,1,68-68" />
        <path style={{ fill: props.couleur || "#fff" }} className="twitter-3 pub-twitter" d="M35.3,99.2A38.73,38.73,0,0,0,53.93,96a33.8,33.8,0,0,0,7.48-4.5,17.82,17.82,0,0,1-7.73-1.94A17.49,17.49,0,0,1,45.15,80c-.38-1-.38-1,.67-.88,2.85.28,4.94.22,6.56-.41a19.21,19.21,0,0,1-4.22-1.62c-6-3.3-9.12-8.4-9.66-15.25-.07-.79.16-.88.89-.53a17.38,17.38,0,0,0,7,1.9c-1.14-1-2.12-1.84-3-2.73a18.28,18.28,0,0,1-2.82-20.25c.44-.89.6-.89,1.2-.19A50.68,50.68,0,0,0,73,57.46c1.27.25,2.66.25,4,.54.89.12,1-.29.85-1A17.9,17.9,0,0,1,107.69,41a2,2,0,0,0,2,.47,33.24,33.24,0,0,0,9.45-3.71,1.69,1.69,0,0,0,.75-.47,17.56,17.56,0,0,1-7.54,9.89,37.75,37.75,0,0,0,9.64-2.5c.06.41-.26.66-.45,1a36.64,36.64,0,0,1-7.41,7.57,1.5,1.5,0,0,0-.67,1.43,52,52,0,0,1-12.33,34.92A48.11,48.11,0,0,1,71.24,106.3c-12.68,2-24.6-.13-35.56-6.91a.67.67,0,0,0-.38-.19" />
    </g>
</svg>



export const logoMtMains = props => <svg
    width={props.width || "90"}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 91.44 90.95">
    <defs>
        <style dangerouslySetInnerHTML={{ __html: ".logoMain-1{fill:none;}.logoMtMains-2{clip-path:url(#logoMtMainsCP);}.logoMtMains-3{fill:#b11f27;}" }} />
        <clipPath id="logoMtMainsCP" transform="translate(0 0)">
            <rect width="91" height="91" />
        </clipPath>
    </defs>
    <g >
        <g >
            <g className="logoMtMains-2">
                <path className="logoMtMains-3" d="M5.3,45.11A20.43,20.43,0,0,0,0,46.38,26.07,26.07,0,0,0,.19,49.9,45,45,0,0,0,7.38,70.34,45.85,45.85,0,0,0,83,71.81a45,45,0,0,0,4-6.76c-1.43-.19-5.82-1.39-6.56-.1a39.41,39.41,0,0,1-4.18,6A39.86,39.86,0,0,1,6.55,52.8,62.43,62.43,0,0,1,5.3,45.11m.08-17.3-1.74,0c-.4.92-.77,1.85-1.11,2.8a45.13,45.13,0,0,0-2.47,12c2.91-.52,5.61-1.37,8.61-1.43,3.25,0,5,2,7.21,4,2.41,2.11,5.49,3.5,8.17,5.21,1.41.9,2.55,2.28,4.13,2.89,1.32.51,4.2.28,3.33-1.83-.14-.16-.14-.22-.29-.3l-.63-.29-.28-.12-.11,0L30,50.54c-1-.52-2.7-1.65-2.94-2.25-.23-.35.18-.32.36-.42s.11,0,.17,0a.45.45,0,0,1,.16,0A1.46,1.46,0,0,1,28,48a2.29,2.29,0,0,1,.64.38,20.76,20.76,0,0,1,2.72,2.38s.24.3.46.55a3.34,3.34,0,0,0,1.19.75l0,0c1.89.83,5,2.18,5.18,1.8a1.33,1.33,0,0,0,.8-2.06c-.71-1-2.24-1.33-3.14-2.12A28.17,28.17,0,0,0,33,47.17c-.2-.13-2.5-2-1.76-1.88,1.18.24,2.33,1.41,3.25,2.12a35.87,35.87,0,0,0,4,2.28c.83.48,1.25,1.08,2.26.74a1.51,1.51,0,0,0,1-2.33c-.57-1-1.9-1.63-2.74-2.4a27.37,27.37,0,0,0-3.56-2.49c-.76-.5-2.36-1.25-2.73-2.08-.63-1.32,1.78-.6,2.1-.46a39.18,39.18,0,0,1,7.58,3.86c.71.53,2,1.76,3,1.48,1.26-.34.83-1.86.28-2.6a19.46,19.46,0,0,0-7.13-5.32c-1-.45-4.29-1.34-5-2.27-.43-.53,2.17,0,4.19-1.26,2.75-2.23-2.94-2.28-4.08-2.71-1.36-.52-2.85-.67-4.22-1.21-1.2-.46-2.35-1-3.55-1.46A10.21,10.21,0,0,0,23,28.77a45.07,45.07,0,0,0-4.63-.35,41,41,0,0,1-4.43.31c-1.45-.05-2.81-.44-4.24-.62a36.74,36.74,0,0,0-4.32-.3M50.13,4c1.29-2.94-2.28-4-4.42-4A46.2,46.2,0,0,0,5,24.7c1.79.18,6.3.75,7.35-.84A39.88,39.88,0,0,1,43.7,5.92C45.91,5.81,49,6.59,50.13,4M85.28,46.35c-3,.67-7,2.15-10.1,1.4-3.91-.94-6-5.89-9.88-6.37-2.17-.27-4.34-1.09-6.49-1.2a7.16,7.16,0,0,1-2.44-.32c-.53-.23-2.13-1.39-2.67-.72-1.53,2,2,3.73,3.26,4.46A8.16,8.16,0,0,1,59.27,45c.45.52-2.39.75-2.75.82-2.15.48-4.88.15-6.83,1.21-1.44.79-5.65,2.62-3.79,5,.8,1,1.71.25,2.56-.25a13.61,13.61,0,0,1,4-1.4,11.71,11.71,0,0,1,3.66-.45c1.46.15,1.17,1.36-.15,1.51-2,.24-4.9,0-6,2.16a2.36,2.36,0,0,0,.6,2.91c.78.68,2.06-.24,2.93,0,.21.41-.93,1.68-1,2.26a1.69,1.69,0,0,0,1.64,1.89c.38,0,3.2-.5,3.06,0-.28,1.13-.65,1.94.35,2.83,1.78,1.56,5.83.71,8,.8,2.69.1,5.19.48,7.75-.65,2.36-1,4-2.33,6.72-2.08s5.42.68,8.15.81a44.32,44.32,0,0,0,3.25-17.65c-2.08.42-4.08,1.2-6.15,1.66m5.06-4.28,1-.29c-.07-.78-.15-1.55-.25-2.31A45.82,45.82,0,0,0,90.22,35c-.66-2.78-3.08-14-7.88-11.31-3.26,1.81.15,6.37,1,8.69a40.5,40.5,0,0,1,2.16,10.85,31.73,31.73,0,0,0,4.88-1.12" transform="translate(0 0)" />
            </g>
        </g>
    </g>
</svg>


export const ecouter = props => <svg
    version="1.1"
    id="ecouter"
    className="icone"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px" y="0px"
    viewBox="0 0 162 153"
    style={{ enableBackground: 'new 0 0 162 153' }}
    xmlSpace="preserve"
    width={props.width || 80}
>
    <style type="text/css"
        dangerouslySetInnerHTML={
            { __html: "\n\t.ecouter0{clip-path:url(#ecouterCP);fill:none;stroke:#FFFFFF;stroke-width:1.969;stroke-miterlimit:10;}\n\t.ecouter1{clip-path:url(#ecouterCP);fill:none;stroke:#FFFFFF;stroke-width:1.95;}\n" }} />
    <g>
        <defs>
            <rect id="ecouter2" x={13} y="10.1" width="135.9" height="135.9" />
        </defs>
        <clipPath id="ecouterCP">
            <use xlinkHref="#ecouter2" style={{ overflow: 'visible' }} />
        </clipPath>
        <path className="ecouter0" d="M76.9,52c-0.6,0-1.2,0.3-1.6,1L63.1,64.4h-9.6c-0.6,0-1.2,0.3-1.6,1c-0.5,0.7-0.7,1.5-0.7,2.4v20.5
        c0,0.9,0.2,1.7,0.7,2.4c0.5,0.7,1,1,1.6,1h9.6l12.2,11.4c0.5,0.7,1,1,1.6,1c0.6,0,1.2-0.3,1.6-1c0.5-0.7,0.7-1.5,0.7-2.4V55.4
        c0-0.9-0.2-1.7-0.7-2.4C78,52.3,77.5,52,76.9,52z" />
        <path className="ecouter0" d="M100.1,56.4c0,0,23.7,20.3-0.1,43.7" />
        <path className="ecouter0" d="M92,63.9c0,0,17.7,13.1,0,30" />
        <ellipse className="ecouter1" cx="80.9" cy="78.1" rx="65.9" ry="65.9" />
    </g>
</svg>

export const lire = props => <svg
    id="lire"
    className="icone"
    width={props.width || 80}
    version="1.1" id="lire" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 162 153" style={{ enableBackground: 'new 0 0 162 153' }} xmlSpace="preserve">
    <style type="text/css" dangerouslySetInnerHTML={{ __html: "\n.st0{clip-path:url(#lireCP);fill:none;stroke:#FFFFFF;stroke-width:1.95;}\n.lire1{clip-path:url(#lireCP);fill:#FFFFFF;}\n" }} />
    <g>
        <defs>
            <rect id="lire-1" x="12.5" y="8.1" width="136.9" height="136.9" />
        </defs>
        <clipPath id="lireCP">
            <use xlinkHref="#lire-1" style={{ overflow: 'visible' }} />
        </clipPath>
        <ellipse className="st0" cx="80.9" cy="76.6" rx="66.4" ry="66.4" />
        <path className="lire1" d="M99.3,87.4c0,0.8-0.7,1.4-1.5,1.4h-35c-0.9,0-1.5-0.6-1.5-1.4s0.7-1.4,1.5-1.4h35C98.6,86,99.3,86.6,99.3,87.4
    M99.3,78.2c0,0.8-0.7,1.4-1.5,1.4h-35c-0.9,0-1.5-0.6-1.5-1.4c0-0.8,0.7-1.4,1.5-1.4h35C98.6,76.8,99.3,77.4,99.3,78.2 M99.3,69.1
   c0,0.8-0.7,1.4-1.5,1.4h-35c-0.9,0-1.5-0.6-1.5-1.4c0-0.8,0.7-1.4,1.5-1.4h35C98.6,67.7,99.3,68.4,99.3,69.1 M62.7,58.4h35
   c0.9,0,1.5,0.6,1.5,1.4c0,0.8-0.7,1.4-1.5,1.4h-35c-0.9,0-1.5-0.6-1.5-1.4C61.2,59,61.9,58.4,62.7,58.4 M106.4,106.4
   c0,0.4-0.4,0.7-0.8,0.7H56.2c-0.4,0-0.8-0.3-0.8-0.7V43c0-0.4,0.4-0.7,0.8-0.7h37.3v10.8c0,1,0.9,1.9,2.1,1.9h10.8V106.4z
    M97.7,45.2l6.1,6h-6.1V45.2z M96.5,38.6H56.2c-2.7,0-4.9,2-4.9,4.4v63.3c0,2.4,2.2,4.4,4.9,4.4h49.4c2.7,0,4.9-2,4.9-4.4V52.3
   L96.5,38.6z" />
    </g>
</svg>

export const regarder = props => <svg
    width={props.width || 80}
    className="icone"
    version="1.1"
    id="regarder"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px" y="0px" viewBox="0 0 162 153"
    style={
        { enableBackground: 'new 0 0 162 153' }}
    xmlSpace="preserve">
    <style type="text/css"
        dangerouslySetInnerHTML={
            { __html: "\n.regarder0{clip-path:url(#regarderCP);fill:none;stroke:#FFFFFF;stroke-width:1.95;}\n.regarder1{fill:none;stroke:#FFFFFF;stroke-width:1.976;stroke-miterlimit:10;}\n.regarder2{clip-path:url(#SVGID_4_);fill:none;stroke:#FFFFFF;stroke-width:1.976;stroke-miterlimit:10;}\n" }} />
    <g>
        <defs>
            <rect id="regarder3" x="13.9" y={11} width={134} height={134} />
        </defs>
        <clipPath id="regarderCP">
            <use xlinkHref="#regarder3" style={{ overflow: 'visible' }} />
        </clipPath>
        <ellipse className="regarder0" cx="80.9" cy={78} rx={65} ry={65} />
    </g>
    <polygon className="regarder1" points="90.7,73.6 90.7,90.5 111.9,101.7 111.9,62.4 " />
    <g>
        <defs>
            <rect id="regarder5" x="13.9" y={11} width={134} height={134} />
        </defs>
        <clipPath id="regarder5">
            <use xlinkHref="#regarder4" style={{ overflow: 'visible' }} />
        </clipPath>
        <path className="regarder2" d="M86.5,62.5h-32c-2,0-3.6,2.2-3.6,4.9v29.3c0,2.7,1.6,4.9,3.6,4.9h32c2,0,3.6-2.2,3.6-4.9v-4.9v-4.2V76.5v-4.2
   v-4.9C90.1,64.7,88.5,62.5,86.5,62.5z" />
    </g>
</svg>





export const soundCloud = props => <svg
    width={props.width || 80}
    id="soundCloud"
    data-name="soundCloud"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 1018 1018">
    <defs>
        <style dangerouslySetInnerHTML={{ __html: ".soundCloud-1{fill:none;}.soundCloud-2{clip-path:url(#soundCloudCP);}.soundCloud-3{fill:#fff;}" }} />
        <clipPath id="soundCloudCP">
            <rect className="soundCloud-1" x="-0.37" width="1018.37" height="1018.37" />
        </clipPath>
    </defs>
    <g className="soundCloud-2">
        <path style={{ fill: props.couleur || "#fff" }} className="soundCloud-3" d="M877.31,543.44A92.29,92.29,0,0,1,792,671.84l.1.19H536a10.92,10.92,0,0,1-10.06-10.61V368c.11-5.36,1.93-8.21,8.91-10.9a164.67,164.67,0,0,1,59.08-11.09c85.21,0,155,65.32,162.38,148.6a92.26,92.26,0,0,1,121,48.79M521.72,586.06l-4.39,75.74a10.19,10.19,0,1,1-20.37,0l-2.1-37.3-2.1-38.25L497,379.13v-1.05a10.16,10.16,0,0,1,3.74-8,10,10,0,0,1,11.55-.86,10.56,10.56,0,0,1,5,8.69Zm-32.6.19-3.63,69-.4,7.54a9.61,9.61,0,0,1-9.56,9.58,9.53,9.53,0,0,1-9.45-9.09,1.21,1.21,0,0,1,0-.38s-3.65-76.6-3.65-76.69l3.65-188.95v-1.82a9.51,9.51,0,0,1,4.39-7.94,9.24,9.24,0,0,1,10.34.1,9.61,9.61,0,0,1,4.28,7.84Zm-31.84,0-4.49,77.08a8.9,8.9,0,0,1-17.79.09l-3.93-77.17L435,425.91a8.9,8.9,0,1,1,17.79,0Zm-31.76-.19-4.87,77.73a8.22,8.22,0,1,1-16.44,0l-4.39-77.63,4.3-166.58a8.27,8.27,0,1,1,16.53,0Zm-31.46,0-5.25,78.41a7.65,7.65,0,0,1-15.21,0l-4.77-78.41,4.77-170.78a7.65,7.65,0,0,1,15.21,0Zm-31.06,0-5.84,79a7,7,0,1,1-14,0l-5.08-79,5.16-165.32a7,7,0,1,1,14,0Zm-31.47.48-6.21,79.75a6.32,6.32,0,0,1-12.63,0l-5.54-79.75L312.69,434a6.32,6.32,0,1,1,12.63,0Zm-30.22-.48-6.68,80.23a5.74,5.74,0,0,1-11.39,0l-5.83-80.23,5.94-124.22a5.73,5.73,0,0,1,11.36,0Zm-30.5,0-7.08,80.23a5.07,5.07,0,0,1-10,0l-6.21-80.23,6.21-76.31a5.07,5.07,0,0,1,10,0Zm-30.2,0-7.48,79.56a4.44,4.44,0,1,1-8.88,0l-6.6-79.56,6.6-82.23a4.44,4.44,0,1,1,8.88,0Zm-29.93,0-7.94,77.08a3.73,3.73,0,0,1-7.46,0l-7-77.08,7-80A3.82,3.82,0,0,1,199,502.3a4,4,0,0,1,3.74,3.74ZM181,586l-8.4,66a3.16,3.16,0,0,1-6.32,0l-7.36-66,7.36-67.51a3.16,3.16,0,1,1,6.32,0Zm-29.83.08L144.68,627a3,3,0,0,1-6,0l-5.47-41,5.47-41.7a3,3,0,1,1,6,0ZM1018,509.19C1018,228,790,0,508.82,0S-.37,228-.37,509.19s228,509.17,509.19,509.17S1018,790.4,1018,509.19" />
    </g>
</svg>

export const music = props => <svg
    width={props.width || 80}
    id="music"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 966 966">
    <defs>
        <style dangerouslySetInnerHTML={{ __html: ".music-1,.music-3{fill:none;}.music-2{clip-path:url(#musicCP);}.music-3{stroke:#fff;stroke-width:14.17px;}.music-4{fill:#fff;}" }} />
        <clipPath id="musicCP">
            <rect className="music-1" x="-0.37" width={966} height={966} />
        </clipPath>
    </defs>
    <g className="music-2">
        <path style={{ stroke: props.couleur || "#fff" }} className="music-3" d="M482.63,946.57C738.65,946.57,946.2,739,946.2,483S738.65,19.44,482.63,19.44,19.07,227,19.07,483,226.61,946.57,482.63,946.57Z" />
        <path style={{ fill: props.couleur || "#fff" }} className="music-4" d="M375.68,226l268.75-54.85s41.13-19.19,41.13,38.4V612.67s11,93.24-93.24,93.24-93.23-68.56-93.23-68.56-8.23-63.07,101.46-63.07c0,0,46.62,13.71,49.36-38.39s0-202.93,0-202.93,2.75-24.68-32.9-16.45-222.13,43.87-222.13,43.87-21.94,2.74-21.94,30.17V681.23s11,85-98.72,85c0,0-85,8.23-85-65.81s101.46-65.82,128.89-65.82c0,0,19.19,2.74,19.19-32.91V267.14s-5.48-32.9,38.39-41.13" />
    </g>
</svg>



export const lireMin = props => <svg
    width={props.width || 40}
    id="lireMin"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 16 20">
    <defs>
        <style dangerouslySetInnerHTML={{ __html: ".lireMin-1{fill:none;}.lireMin-2{clip-path:url(#lireMinCP);}" }} />
        <clipPath id="lireMinCP">
            <rect className="lireMin-1" x="0.04" y="0.72" width="15.36" height="18.74" />
        </clipPath>
    </defs>
    <g className="lireMin-2">
        <path className="lireMin-3" style={{ fill: props.color || "#3f3f40" }} d="M12.49,13.38a.38.38,0,0,1-.4.36H3A.36.36,0,1,1,3,13h9.09a.38.38,0,0,1,.4.36m0-2.39a.38.38,0,0,1-.4.36H3a.36.36,0,1,1,0-.72h9.09a.38.38,0,0,1,.4.36m0-2.35a.38.38,0,0,1-.4.36H3a.36.36,0,1,1,0-.72h9.09a.38.38,0,0,1,.4.36M3,5.85h9.09a.36.36,0,1,1,0,.72H3a.36.36,0,1,1,0-.72M14.33,18.31a.19.19,0,0,1-.2.18H1.31a.19.19,0,0,1-.2-.18V1.87a.2.2,0,0,1,.2-.19H11v2.8a.51.51,0,0,0,.53.48h2.79ZM12.08,2.44,13.67,4H12.08ZM11.78.72H1.31A1.21,1.21,0,0,0,0,1.87V18.31a1.22,1.22,0,0,0,1.27,1.15H14.13a1.22,1.22,0,0,0,1.27-1.15v-14Z" />
    </g>
</svg>

export const regarderMin = props => <svg
    width={props.width || 40}
    id="voirMin"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 21 14">
    <defs>
        <style dangerouslySetInnerHTML={{ __html: ".voirMin-1,.voirMin-3,.voirMin-4{fill:none;}.voirMin-2{clip-path:url(#regarderMinCP);}.voirMin-4{stroke-miterlimit:10;}" }} />
        <clipPath id="regarderMinCP">
            <rect className="voirMin-1" x="0.62" y="0.16" width="20.19" height="13.85" />
        </clipPath>
    </defs>
    <g className="voirMin-2">
        <path className="voirMin-3" style={{ stroke: props.color || "#3f3f40" }} d="M14.12.66H2.42a1.46,1.46,0,0,0-1.3,1.57V11.6a1.45,1.45,0,0,0,1.3,1.56h11.7a1.45,1.45,0,0,0,1.3-1.56V2.23A1.46,1.46,0,0,0,14.12.66Z" />
        <polygon className="voirMin-4" style={{ stroke: props.color || "#3f3f40" }} points="15.31 6.14 16.15 5.69 20.32 1.57 20.32 12.86 15.86 8.66 15.31 6.14" />
    </g>
</svg>

export const ecouterMin = props => <svg
    width={props.width || 40}
    id="ecouterMin"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 19 16">
    <defs>
        <style dangerouslySetInnerHTML={{ __html: ".ecouterMin-1,.ecouterMin-3{fill:none;}.ecouterMin-2{clip-path:url(#ecouterMinCP);}.ecouterMin-3{stroke-miterlimit:10;stroke-width:1.14px;}" }} />
        <clipPath id="ecouterMinCp">
            <rect className="ecouterMin-1" x="0.8" y="0.29" width="17.78" height="15.6" />
        </clipPath>
    </defs>
    <g className="ecouterMin-2">
        <path className="ecouterMin-3" style={{ stroke: props.color || "#3f3f40" }} d="M8,.86a.5.5,0,0,0-.43.28L4.46,4.3H2a.5.5,0,0,0-.42.28,1.21,1.21,0,0,0-.18.66v5.69a1.22,1.22,0,0,0,.18.67.5.5,0,0,0,.42.28H4.46L7.61,15a.5.5,0,0,0,.43.28A.53.53,0,0,0,8.47,15a1.31,1.31,0,0,0,.17-.67V1.81a1.31,1.31,0,0,0-.17-.67A.53.53,0,0,0,8,.86Z" />
        <path className="ecouterMin-3" style={{ stroke: props.color || "#3f3f40" }} d="M15.9,1.91a10.4,10.4,0,0,1,0,12.51" />
        <path className="ecouterMin-3" style={{ stroke: props.color || "#3f3f40" }} d="M13.55,4.08a8,8,0,0,1,0,8.6" />
    </g>
</svg>

export const telechargerMin = props => <svg
    width={props.width || 40}
    id="telechargerMin"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 17 18">
    <defs>
        <style dangerouslySetInnerHTML={{ __html: ".telechargerMin-1,.telechargerMin-4{fill:none;}.telechargerMin-2{clip-path:url(#telechargerMinCP);}.telechargerMin-4{stroke-miterlimit:10;stroke-width:0.58px;}" }} />
        <clipPath id="telechargerMinCP">
            <rect className="telechargerMin-1" x="0.43" y="0.17" width="16.58" height="17.83" />
        </clipPath>
    </defs>
    <g className="telechargerMin-2">
        <path className="telechargerMin-3" style={{ fill: props.color || "#3f3f40" }} d="M4.57,7.66l4,5.77,4-5.77H10.7a.3.3,0,0,1-.31-.31V1.09H6.79V7.35a.31.31,0,0,1-.32.31Zm4,6.62h0a.32.32,0,0,1-.26-.13L3.72,7.53A.31.31,0,0,1,4,7H6.16V.78A.31.31,0,0,1,6.47.47H10.7A.31.31,0,0,1,11,.78V7h2.18a.32.32,0,0,1,.28.17.31.31,0,0,1,0,.32L8.84,14.15a.31.31,0,0,1-.25.13" />
        <path className="telechargerMin-4" style={{ stroke: props.color || "#3f3f40" }} d="M4.57,7.66l4,5.77,4-5.77H10.7a.3.3,0,0,1-.31-.31V1.09H6.79V7.35a.31.31,0,0,1-.32.31Zm4,6.62h0a.32.32,0,0,1-.26-.13L3.72,7.53A.31.31,0,0,1,4,7H6.16V.78A.31.31,0,0,1,6.47.47H10.7A.31.31,0,0,1,11,.78V7h2.18a.32.32,0,0,1,.28.17.31.31,0,0,1,0,.32L8.84,14.15A.31.31,0,0,1,8.59,14.28Z" />
        <path className="telechargerMin-4" style={{ stroke: props.color || "#3f3f40" }} d="M16.46,17.71H1a.26.26,0,0,1-.25-.26V12a.26.26,0,1,1,.51,0v5.17h15V12a.26.26,0,0,1,.52,0v5.43A.26.26,0,0,1,16.46,17.71Z" />
    </g>
</svg>




export const lireCircle = props => <svg
    width={props.width || 25}
    id="lireCircle"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 32 32">
    <defs>
        <style dangerouslySetInnerHTML={{ __html: ".lireCircle-1,.lireCircle-5{fill:none;}.lireCircle-2{clip-path:url(#lireCircleCP);}.lireCircle-3{fill:#87bc3d;}.lireCircle-4{fill:#fff;}.lireCircle-5{stroke:#fff;stroke-miterlimit:10;stroke-width:0.25px;}" }} />
        <clipPath id="lireCircleCP">
            <rect className="lireCircle-1" x="0.03" y="0.03" width="31.95" height="31.95" />
        </clipPath>
    </defs>
    <g className="lireCircle-2">
        <path style={{ fill: props.couleur || "#87bc3d" }} className="lireCircle-3" d="M16,32A16,16,0,1,0,0,16,16,16,0,0,0,16,32" />
        <path className="lireCircle-4" d="M20.37,19a.34.34,0,0,1-.36.32H11.82a.34.34,0,0,1-.36-.32.35.35,0,0,1,.36-.33H20a.35.35,0,0,1,.36.33m0-2.16a.35.35,0,0,1-.36.33H11.82a.35.35,0,0,1-.36-.33.34.34,0,0,1,.36-.32H20a.34.34,0,0,1,.36.32m0-2.11a.34.34,0,0,1-.36.32H11.82a.34.34,0,0,1-.36-.32.35.35,0,0,1,.36-.33H20a.35.35,0,0,1,.36.33m-8.55-2.52H20a.35.35,0,0,1,.36.33.34.34,0,0,1-.36.32H11.82a.34.34,0,0,1-.36-.32.35.35,0,0,1,.36-.33M22,23.44a.17.17,0,0,1-.18.16H10.3a.17.17,0,0,1-.18-.16V8.62a.17.17,0,0,1,.18-.16H19V11a.46.46,0,0,0,.49.43H22ZM20,9.14l1.43,1.4H20Zm-.27-1.55H10.3a1.1,1.1,0,0,0-1.15,1V23.44a1.1,1.1,0,0,0,1.15,1H21.85a1.09,1.09,0,0,0,1.14-1V10.79Z" />
        <path className="lireCircle-5" d="M20.37,19a.34.34,0,0,1-.36.32H11.82a.34.34,0,0,1-.36-.32.35.35,0,0,1,.36-.33H20A.35.35,0,0,1,20.37,19Zm0-2.16a.35.35,0,0,1-.36.33H11.82a.35.35,0,0,1-.36-.33.34.34,0,0,1,.36-.32H20A.34.34,0,0,1,20.37,16.84Zm0-2.11a.34.34,0,0,1-.36.32H11.82a.34.34,0,0,1-.36-.32.35.35,0,0,1,.36-.33H20A.35.35,0,0,1,20.37,14.73Zm-8.55-2.52H20a.35.35,0,0,1,.36.33.34.34,0,0,1-.36.32H11.82a.34.34,0,0,1-.36-.32A.35.35,0,0,1,11.82,12.21ZM22,23.44a.17.17,0,0,1-.18.16H10.3a.17.17,0,0,1-.18-.16V8.62a.17.17,0,0,1,.18-.16H19V11a.46.46,0,0,0,.49.43H22ZM20,9.14l1.43,1.4H20Zm-.27-1.55H10.3a1.1,1.1,0,0,0-1.15,1V23.44a1.1,1.1,0,0,0,1.15,1H21.85a1.09,1.09,0,0,0,1.14-1V10.79Z" />
    </g>
</svg>

export const telechargerCircle = props => <svg
    width={props.width || 25}
    id="telechargerCircle"
    xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 32 32">
    <defs>
        <style dangerouslySetInnerHTML={{ __html: ".telechargerCircle-1,.telechargerCircle-5,.telechargerCircle-6{fill:none;}.telechargerCircle-2{clip-path:url(#telechargerCircleCP);}.telechargerCircle-3{fill:#87bc3d;}.telechargerCircle-4{fill:#fff;}.telechargerCircle-5,.telechargerCircle-6{stroke:#fff;stroke-miterlimit:10;}.telechargerCircle-5{stroke-width:0.51px;}.telechargerCircle-6{stroke-width:0.6px;}" }} />
        <clipPath id="telechargerCircleCP">
            <rect className="telechargerCircle-1" y="0.12" width="31.7" height="31.7" />
        </clipPath>
    </defs>
    <g className="telechargerCircle-2">
        <path style={{ fill: props.couleur || "#87bc3d" }} className="telechargerCircle-3" d="M15.85,31.8A15.85,15.85,0,1,0,0,16V16A15.86,15.86,0,0,0,15.85,31.8" />
        <path className="telechargerCircle-4" d="M11.73,14.45l4,5.72,4-5.72H17.81a.29.29,0,0,1-.31-.29h0V7.93H13.93v6.22a.29.29,0,0,1-.3.3h-1.9Zm4,6.57h0a.29.29,0,0,1-.25-.14l-4.57-6.56a.31.31,0,0,1,0-.32.3.3,0,0,1,.27-.16h2.17V7.62a.31.31,0,0,1,.31-.31h4.19a.29.29,0,0,1,.3.3h0v6.22h2.18a.3.3,0,0,1,.27.16.31.31,0,0,1,0,.32L16,20.88a.31.31,0,0,1-.26.14" />
        <path className="telechargerCircle-5" d="M11.73,14.45l4,5.72,4-5.72H17.81a.29.29,0,0,1-.31-.29h0V7.93H13.93v6.22a.29.29,0,0,1-.3.3h-1.9Zm4,6.57h0a.29.29,0,0,1-.25-.14l-4.57-6.56a.31.31,0,0,1,0-.32.3.3,0,0,1,.27-.16h2.17V7.62a.31.31,0,0,1,.31-.31h4.19a.29.29,0,0,1,.3.3h0v6.22h2.18a.3.3,0,0,1,.27.16.31.31,0,0,1,0,.32L16,20.88a.29.29,0,0,1-.27.14Z" />
        <path className="telechargerCircle-6" d="M23.52,24.42H8.17a.25.25,0,0,1-.25-.25h0V18.77a.26.26,0,1,1,.51,0h0v5.14H23.27V18.77a.26.26,0,0,1,.2-.31.27.27,0,0,1,.31.21.17.17,0,0,1,0,.1v5.39a.25.25,0,0,1-.24.26Z" />
    </g></svg>

export const ecouterCircle = props => <svg
    width={props.width || 25}
    id="ecouterCircle"
    xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 32 32">
    <defs>
        <style dangerouslySetInnerHTML={{ __html: ".ecouterCircle-1,.ecouterCircle-2,.ecouterCircle-5{fill:none;}.ecouterCircle-2,.ecouterCircle-5{stroke:#fff;stroke-miterlimit:10;}.ecouterCircle-2{stroke-width:1.26px;}.ecouterCircle-3{clip-path:url(#ecouterCircleCP);}.ecouterCircle-4{fill:#87bc3d;}.ecouterCircle-5{stroke-width:1.14px;}" }} />
        <clipPath id="ecouterCircleCP">
            <rect className="ecouterCircle-1" x="0.03" y="0.03" width="31.95" height="31.95" />
        </clipPath>
    </defs>
    <polyline className="ecouterCircle-2" points="20.94 16.27 25.35 11.87 25.35 21.91 20.94 17.16" />
    <g className="ecouterCircle-3">
        <path style={{ fill: props.couleur || "#87bc3d" }} className="ecouterCircle-4" d="M16,32A16,16,0,1,0,0,16,16,16,0,0,0,16,32" />
        <path className="ecouterCircle-5" d="M14.35,8.77a.5.5,0,0,0-.42.28l-3.16,3.16H8.29a.5.5,0,0,0-.43.28,1.22,1.22,0,0,0-.18.67v5.68a1.22,1.22,0,0,0,.18.67.5.5,0,0,0,.43.28h2.48L13.93,23a.46.46,0,0,0,.85,0,1.22,1.22,0,0,0,.18-.67V9.72a1.22,1.22,0,0,0-.18-.67A.5.5,0,0,0,14.35,8.77Z" />
        <path className="cecouterCircles-5" d="M22.21,9.83a10.39,10.39,0,0,1,0,12.5" />
        <path className="ecouterCircle-5" d="M19.87,12a8,8,0,0,1,0,8.6" />
    </g></svg>

export const regarderCircle = props => <svg
    width={props.width || 25}
    id="regarderCircle"
    xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 32 32">
    <defs>
        <style dangerouslySetInnerHTML={{ __html: ".regarderCircle-1,.regarderCircle-4,.regarderCircle-5{fill:none;}.regarderCircle-2{clip-path:url(#regarderCircleCP);}.regarderCircle-3{fill:#87bc3d;}.regarderCircle-4,.regarderCircle-5{stroke:#fff;}.regarderCircle-4{stroke-width:1.42px;}.regarderCircle-5{stroke-miterlimit:10;stroke-width:1.26px;}" }} />
        <clipPath id="regarderCircleCP">
            <rect className="regarderCircle-1" x="-0.01" y="0.02" width="31.95" height="31.95" />
        </clipPath>
    </defs>
    <g className="regarderCircle-2">
        <path style={{ fill: props.couleur || "#87bc3d" }} className="regarderCircle-3" d="M16,32A16,16,0,1,0,0,16,16,16,0,0,0,16,32" />
        <path className="regarderCircle-4" d="M19.79,10.17H8.1a1.45,1.45,0,0,0-1.3,1.56v9.38a1.45,1.45,0,0,0,1.3,1.56H19.79a1.45,1.45,0,0,0,1.3-1.56V11.73A1.45,1.45,0,0,0,19.79,10.17Z" />
    </g>
    <polyline className="regarderCircle-5" points="20.94 16.27 25.35 11.87 25.35 21.91 20.94 17.16" />
</svg>


export const play = props => <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || 40}
    // height={512} 
    viewBox="0 0 512 512">
    <path
        d="M448,256c0-106-86-192-192-192S64,150,64,256s86,192,192,192S448,362,448,256Z"
        style={{ fill: 'none', stroke: props.couleur || '#000', strokeMiterlimit: 10, strokeWidth: 32 }}
    />
    <path style={{ fill: props.couleur || '#000' }} d="M216.32,334.44,330.77,265.3a10.89,10.89,0,0,0,0-18.6L216.32,177.56A10.78,10.78,0,0,0,200,186.87V325.13A10.78,10.78,0,0,0,216.32,334.44Z" />
</svg>


export const stop = props => <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || 40}
    // height={512} 
    viewBox="0 0 512 512">
    <path
        d="M448,256c0-106-86-192-192-192S64,150,64,256s86,192,192,192S448,362,448,256Z"
        style={{ fill: 'none', stroke: props.couleur || '#000', strokeMiterlimit: 10, strokeWidth: 32 }} />
    <path style={{ fill: props.couleur || '#000' }} d="M310.4,336H201.6A25.62,25.62,0,0,1,176,310.4V201.6A25.62,25.62,0,0,1,201.6,176H310.4A25.62,25.62,0,0,1,336,201.6V310.4A25.62,25.62,0,0,1,310.4,336Z" />
</svg>

export const play2 = props => <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || 40}
    // height={512} 
    viewBox="0 0 512 512">
    <path style={{ fill: props.couleur || '#000' }} d="M190.06,414,353.18,274.22a24,24,0,0,0,0-36.44L190.06,98c-15.57-13.34-39.62-2.28-39.62,18.22V395.82C150.44,416.32,174.49,427.38,190.06,414Z" />
</svg>


export const logoCalvinEdition = props => <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 1279.93 296.13">
    <defs>
        <style dangerouslySetInnerHTML={{ __html: ".logoCalvinEdition1{fill:none;}.logoCalvinEdition2{clip-path:url(#cplogoCalvinEdition);}.logoCalvinEdition3{fill:#2a292a;}" }} />
        <clipPath id="cplogoCalvinEdition" transform="translate(-0.07 -358.02)">
            <rect className="logoCalvinEdition1" x="0.07" y="358.02" width="1279.93" height="296.13" />
        </clipPath>
    </defs>
    <g className="logoCalvinEdition2">
        <path className="logoCalvinEdition3" d="M10,402.15a11,11,0,0,0,1.07,4.93A8.23,8.23,0,0,0,14,410.44a7.34,7.34,0,0,0,4.09,1.21,6.1,6.1,0,0,0,3.62-1,8.77,8.77,0,0,0,2.4-2.5,38.09,38.09,0,0,0,2.12-3.86,21.75,21.75,0,0,1,2.53-4.41,3.72,3.72,0,0,1,3.06-1.46,4.48,4.48,0,0,1,2.41.71,5,5,0,0,1,1.82,2,6.76,6.76,0,0,1,.68,3.07A10.27,10.27,0,0,1,36,407.9a10.57,10.57,0,0,1-2.29,3.52l.22.5,3.73.45a15,15,0,0,0,1.52-3.84,16.14,16.14,0,0,0,.53-4,11.12,11.12,0,0,0-1.14-5.09A8.66,8.66,0,0,0,35.48,396a7.57,7.57,0,0,0-4.18-1.23,6.11,6.11,0,0,0-3.63,1.07,9.32,9.32,0,0,0-2.48,2.57,33,33,0,0,0-2.12,3.95c-.63,1.31-1.18,2.34-1.63,3.09a7.15,7.15,0,0,1-1.62,1.89,3.34,3.34,0,0,1-2.16.75,4.32,4.32,0,0,1-2.27-.66,4.82,4.82,0,0,1-1.77-1.91,6,6,0,0,1-.68-2.93,8.46,8.46,0,0,1,.54-2.93A10.65,10.65,0,0,1,15,396.88l-.18-.65-3.5-.59A17.34,17.34,0,0,0,10,402.15m.14,23.63.27,3.41,23.14,0v.32l-23.32,15v3.78l20.5-.09,8.64.13v-3.27l-9.59.05L16,445.06v-.23l23.32-15.09v-3.82L30.8,426Zm2.77,48.42c0-3,1-5.19,3-6.66s5-2.21,9-2.21q12,0,12,9.1a7.74,7.74,0,0,1-3,6.66q-3,2.21-9.23,2.2-11.73,0-11.73-9.09m-3-.22q0,6.27,3.91,9.65T25,487c4.69,0,8.32-1.07,10.86-3.21s3.82-5.17,3.82-9.11q0-6.31-4-9.73t-11.48-3.41q-6.91,0-10.59,3.21T9.94,474m.27,25.5v3.72L30.58,503l8.77.22v-3.68l-9.09.18Zm0,16.45v19.78L13,536l.36-.23-.27-5.18v-3l17.46-.22,8.77.27V524l-9.09.13L13.12,524v-3l.27-5.09-2.82-.27Zm0,31.91v3.73l20.37-.23,8.77.23v-3.68l-9.09.18Zm26.37,30.28c0,.73,0,1.75-.07,3.07s-.12,2.45-.21,3.38l-6,.14-17-.18q-.19-3.72-.19-6.59,0-9.42,11.46-9.41c4,0,7,.83,9,2.47a8.69,8.69,0,0,1,3,7.12M10,577.67l.18,10.5v0L30.58,588l8.77.23v0c.09-1.52.16-3.16.2-4.94s.07-3.27.07-4.52c0-4.49-1.36-7.92-4.09-10.32s-6.65-3.59-11.78-3.59q-6.63,0-10.18,3.32T10,577.67m-10,26.91c1.55,2.6,3.1,5.5,4.68,8.68l1.64-.64.18-.41q-1.91-4.59-3.91-8.91l-.36-.09-2.14.91ZM36.17,601l.18,7-.05,5.77-6,.14-4.33,0,0-5.18.09-5.09-2.82-.32-.32.27.14,4.82-.09,5.46-9.54-.09-.09-5.78.13-6.86-2.82-.28-.36.19V617.4l20.37-.23,8.77.23V601l-2.82-.27Z" transform="translate(-0.07 -358.02)" />
        <path className="logoCalvinEdition3" d="M1128.47,536.79" transform="translate(-0.07 -358.02)" />
        <path className="logoCalvinEdition3" d="M1262.18,478q0-16-8.42-23.09t-23.65-7.09a53.62,53.62,0,0,0-26.38,6.39,61.75,61.75,0,0,0-19.28,16.3l0-20.66h-45.17v11.54q17.41,0,17.42,9.12v61.77q0,9.12-17.42,9.12V553H1198V541.44q-13.58,0-13.57-9.12V490.6a49.94,49.94,0,0,1,14.78-19.24,39.2,39.2,0,0,1,9.83-5.67,28.32,28.32,0,0,1,10.43-2,12.89,12.89,0,0,1,10.93,5.47q4.05,5.47,4.05,18.23v45q0,9.12-13.57,9.12V553H1280V541.44q-17.82,0-17.82-9.12Z" transform="translate(-0.07 -358.02)" />
        <path className="logoCalvinEdition3" d="M1023.34,437.89a14.41,14.41,0,0,0-10.54-4.4,14.81,14.81,0,0,0-10.63,4.31,14.79,14.79,0,0,0-3.25,16.51,15.65,15.65,0,0,0,8,8,14.84,14.84,0,0,0,16.51-3.25,14.83,14.83,0,0,0,4.31-10.63,14.39,14.39,0,0,0-4.39-10.54m2.28,40.05H986.44v10q15.12,0,15.11,8.08v53.41q0,7.89-15.11,7.9v10h54.46v-10q-15.63,0-15.28-7.9Z" transform="translate(-0.07 -358.02)" />
        <path className="logoCalvinEdition3" d="M888.12,455.72H849.65v10h6.67q7.56,0,7.56,4.75a5.52,5.52,0,0,1-.71,2.8L839.46,530.2,816.1,471.88a6.94,6.94,0,0,1-.53-2.81c0-2.22,1.69-3.34,5.09-3.34h9.48v-10H779.2v10q9.66,0,12.3,6.15l30.21,73.25h22.67l30.21-73.43a8.35,8.35,0,0,1,4.83-4.48,22.8,22.8,0,0,1,8.7-1.49Z" transform="translate(-0.07 -358.02)" />
        <path className="logoCalvinEdition3" d="M665.59,432.79H626.42v10q15.11,0,15.11,7.9v99.42q0,7.92-15.11,7.91v10h54.45V558q-15.27,0-15.28-7.91Z" transform="translate(-0.07 -358.02)" />
        <path className="logoCalvinEdition3" d="M486.63,520.54a30.82,30.82,0,0,1-26.17,14.23q-9,0-13.35-3.52t-4.39-9.83a14.29,14.29,0,0,1,2.63-8.79,22.31,22.31,0,0,1,8.09-6.23,79.34,79.34,0,0,1,13.7-5.09q8.25-2.38,19.49-5.19Zm23-35.95q0-9.51-3.43-15.76A26.26,26.26,0,0,0,497,459a39.61,39.61,0,0,0-13.35-5.1,80.16,80.16,0,0,0-15.64-1.5,67.9,67.9,0,0,0-17.82,2.14,45.7,45.7,0,0,0-13.09,5.63A27.09,27.09,0,0,0,429,468a16.17,16.17,0,0,0-2.8,8.78q0,5.79,3.07,9t9.22,3.25q6.15,0,9.31-3.07a10.64,10.64,0,0,0,3.17-8,7.87,7.87,0,0,0-2.82-6.5,12.23,12.23,0,0,0-6.85-2.64,27.55,27.55,0,0,1,9.75-4.74,54.81,54.81,0,0,1,15-1.76,23,23,0,0,1,9.14,1.67,17.38,17.38,0,0,1,10.1,11.33,29.08,29.08,0,0,1,1.14,8.26v5.44q-7.72,2.12-15.54,3.52t-15.12,2.9q-7.29,1.49-13.7,3.34a40.73,40.73,0,0,0-11.24,5,23.58,23.58,0,0,0-7.56,7.82,22.89,22.89,0,0,0-2.72,11.68q0,11.6,7.64,18.36t24.16,6.76a50.22,50.22,0,0,0,12.83-1.58,44.25,44.25,0,0,0,10.71-4.31,37,37,0,0,0,8.17-6.23,29.77,29.77,0,0,0,5.36-7.38,39.41,39.41,0,0,0,1.93,6.68,17.48,17.48,0,0,0,3.51,5.61,17,17,0,0,0,5.62,4,19.79,19.79,0,0,0,8.08,1.49,27.85,27.85,0,0,0,7.82-1.05,15.21,15.21,0,0,0,6.23-3.52,15.7,15.7,0,0,0,4.05-6.51,30.49,30.49,0,0,0,1.4-9.86v-7.92h-8.25v10.38a11.61,11.61,0,0,1-1.23,5.37,4,4,0,0,1-3.69,2.38q-5.28,0-5.27-7.75Z" transform="translate(-0.07 -358.02)" />
        <path className="logoCalvinEdition3" d="M354.77,364.51H326.29l-9.62,24q-11.18-12-33.3-21.24T230.05,358a173.5,173.5,0,0,0-57,9.17A128.37,128.37,0,0,0,126.7,394.9q-19.85,18.53-31.19,47T84.16,509q0,37.07,11.55,64.38t31.75,45.27a131.4,131.4,0,0,0,47.16,26.76,186.64,186.64,0,0,0,58.12,8.78q29.64,0,51.21-8.2t36.56-21.56A114.38,114.38,0,0,0,345,593.86a178.77,178.77,0,0,0,14.82-35.49L334,549.59q-10.39,33.58-33.5,52.09t-63.13,18.51a97,97,0,0,1-37.14-6.87,75.94,75.94,0,0,1-28.87-20.8q-12.14-13.92-18.86-35.1t-6.74-49.8a197.78,197.78,0,0,1,5.39-47.7q5.38-21.76,16.74-37.4a77.56,77.56,0,0,1,29.45-24.43q18.09-8.76,43.5-8.78,34.65,0,56.39,19.47t29.45,51.52l28.1-2.29Z" transform="translate(-0.07 -358.02)" />
    </g>
</svg>

